import {
  useDashboardMaritimeWarningSettingsQuery,
  useDashboardPublicWarningSettingsQuery,
} from "@/features/admin/features/dashboards/hooks/queries";
import { hasMaritimeWarningsEnabled } from "@/lib/maritime-warning-page-settings.utils";
import type { WarningPageVisibility } from "@/lib/navigation-element-kinds";

/**
 * "Show page" switches of the built-in warning pages, with the same rules as the dashboard
 * nav (maritime also needs a domain). Both queries are invalidated by the settings forms.
 */
export function useWarningPageVisibility(dashboardId: string): WarningPageVisibility {
  const publicSettings = useDashboardPublicWarningSettingsQuery(dashboardId).data;
  const maritimeSettings = useDashboardMaritimeWarningSettingsQuery(dashboardId).data;

  return {
    publicWarningsPage: publicSettings && publicSettings.enabled !== false,
    maritimeWarningsPage: maritimeSettings && hasMaritimeWarningsEnabled(maritimeSettings),
  };
}
